import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'
import classNames from 'classnames'

import EmailForm from '@components/email_form'
import styles from '@components/blocks/contact_form_block.module.scss'

const ContactForm = props => {
  const {
    fields,
    form,
    handleSubmit,
    setEmailValue,
    setMessageValue,
    setNameValue,
    setOrganizationValue,
  } = props

  const {
    emailField,
    errorMessage,
    messageField,
    messageLengthErrorMessage,
    nameField,
    organizationField,
    submitField,
    successMessage,
    title,
  } = fields

  const { email, error, message, name, organization, submitting, success, validationErrors } = form

  const buttonContent = submitting ? <CircularProgress /> : submitField

  const hasMessageLengthError = validationErrors.length
  const hasOtherError = error && !validationErrors.length

  return (
    <div className={classNames('contactForm', styles.contactForm)}>
      <div className={styles.contactForm__content}>
        <h2 className={styles.contactForm__header}>{title}</h2>
        <form
          id="contactForm"
          className="vroomForm__form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <div className="vroomForm__row">
            <TextField
              variant="standard"
              error={validationErrors.name}
              classes={{ root: 'vroomForm__field--half' }}
              label={nameField}
              name="name"
              value={name}
              onChange={setNameValue}
              id="nameField"
            />
            <TextField
              variant="standard"
              error={validationErrors.email}
              classes={{ root: 'vroomForm__field--half' }}
              label={emailField}
              value={email}
              onChange={setEmailValue}
              name="email"
              id="emailField"
              required
            />
          </div>
          <div className="vroomForm__row">
            <TextField
              variant="standard"
              error={validationErrors.organization}
              classes={{ root: 'vroomForm__field--full' }}
              label={organizationField}
              value={organization}
              onChange={setOrganizationValue}
              name="organization"
              id="organizationField"
            />
          </div>
          <div className="vroomForm__row">
            <TextField
              variant="standard"
              error={validationErrors.message}
              classes={{ root: 'vroomForm__field--full' }}
              label={messageField}
              value={message}
              onChange={setMessageValue}
              name="message"
              id="messageField"
              rows="4"
              multiline
              required
            />
          </div>
        </form>
      </div>
      <div className="vroomForm__submitField">
        <button
          disabled={submitting}
          className="vroomForm__submitButton"
          onClick={handleSubmit}
          name="submit"
        >
          {buttonContent}
        </button>
        {hasMessageLengthError && (
          <p className="vroomForm__errorMessage">{messageLengthErrorMessage}</p>
        )}
        {hasOtherError && <p className="vroomForm__errorMessage">{errorMessage}</p>}
        {success && <p className="vroomForm__successMessage">{successMessage}</p>}
      </div>
    </div>
  )
}

export default EmailForm({
  newsletter: false,
  source: 'SUPPORT_REQUEST',
  validate: ({ email, message }) => {
    const errors = {}
    if (email.length < 3) errors.email = true
    if (message.length < 1) errors.message = true
    if (message.length > 255) {
      errors.message = true
      errors.length = true
    }
    return errors
  },
})(ContactForm)
